module.exports = __webpack_public_path__ + "static/media/avocado_maxi_plan.ff1857af.jpg";